/* DMIXER-VARIANT-TIERS: START — Global campaign activation. */
(() => {
  const ACTIVE_ATTRIBUTE =
    'data-dmixer-variant-tier-campaign-active';

  const CONFIG_SELECTOR =
    'script[data-dmixer-config="advanced-integrations"]';

  const CAMPAIGN_PRIORITY = 32461;

  const setCampaignState = (active) => {
    document.documentElement.toggleAttribute(
      ACTIVE_ATTRIBUTE,
      active,
    );
  };

  const syncCampaignState = () => {
    const configElement =
      document.querySelector(CONFIG_SELECTOR);

    if (!configElement?.textContent?.trim()) {
      setCampaignState(false);
      return;
    }

    try {
      const config = JSON.parse(configElement.textContent);
      const campaigns = config?.campaigns?.product ?? [];

      const campaignActive =
        Array.isArray(campaigns) &&
        campaigns.some(
          (campaign) =>
            Number(campaign?.pr) === CAMPAIGN_PRIORITY,
        );

      setCampaignState(campaignActive);
    } catch {
      setCampaignState(false);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      syncCampaignState,
      { once: true },
    );
  } else {
    syncCampaignState();
  }

  document.addEventListener(
    'shopify:section:load',
    syncCampaignState,
  );
})();
/* DMIXER-VARIANT-TIERS: END — Global campaign activation. */

/* DMIXER-VARIANT-TIERS: START — Quantity-based strike-through price sync. */
(() => {
  const CANDIDATE_CLASS = 'price--dmixer-candidate';

  const TIER_DATA_SELECTOR =
    'script[data-dmixer-tier-prices]';

  const readTierData = (priceContainer) => {
    const dataElement =
      priceContainer.querySelector(TIER_DATA_SELECTOR);

    if (!dataElement?.textContent?.trim()) return null;

    try {
      return JSON.parse(dataElement.textContent);
    } catch {
      return null;
    }
  };

  const syncSectionPrice = (sectionId) => {
    if (!sectionId) return;

    const quantityInput = document.getElementById(
      `Quantity-${sectionId}`,
    );
    const priceContainer = document.getElementById(
      `price-${sectionId}`,
    );

    if (!quantityInput || !priceContainer) return;

    const priceElement =
      priceContainer.querySelector('.price');
    const saleBlock = priceContainer.querySelector(
      '.price__dmixer-sale',
    );
    const tierData = readTierData(priceContainer);

    if (!priceElement || !saleBlock || !tierData) return;

    const quantity =
      Number.parseInt(quantityInput.value, 10) || 0;
    const variantPriceMinor = Number(
      tierData.variantPriceMinor,
    );

    const tiers = Array.isArray(tierData.tiers)
      ? tierData.tiers
      : [];

    const applicableTier = tiers
      .filter(
        (tier) =>
          quantity >= Number(tier?.quantityLimit) &&
          Number(tier?.unitPriceMinor) > 0 &&
          Number(tier?.unitPriceMinor) < variantPriceMinor,
      )
      .sort(
        (firstTier, secondTier) =>
          Number(secondTier.quantityLimit) -
          Number(firstTier.quantityLimit),
      )[0];

    if (applicableTier?.formattedPrice) {
      const salePriceElement = saleBlock.querySelector(
        '.price-item--sale',
      );

      if (salePriceElement) {
        salePriceElement.textContent =
          applicableTier.formattedPrice;
      }

      priceElement.classList.add(CANDIDATE_CLASS);
    } else {
      priceElement.classList.remove(CANDIDATE_CLASS);
    }
  };

  const syncAllSections = () => {
    document
      .querySelectorAll('quantity-input[data-section]')
      .forEach((element) =>
        syncSectionPrice(element.dataset.section),
      );
  };

  document.addEventListener('change', (event) => {
    const input = event.target;

    if (
      !(input instanceof HTMLInputElement) ||
      input.name !== 'quantity'
    ) {
      return;
    }

    syncSectionPrice(
      input.closest('quantity-input')?.dataset?.section,
    );
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      syncAllSections,
      { once: true },
    );
  } else {
    syncAllSections();
  }

  document.addEventListener(
    'shopify:section:load',
    syncAllSections,
  );

  /*
    pubsub.js and constants.js load (deferred) before this file, so the
    theme's variant-change and quantity-rule updates re-run the sync after
    the price container is re-rendered.
  */
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, () =>
      syncAllSections(),
    );
    subscribe(PUB_SUB_EVENTS.quantityUpdate, () =>
      syncAllSections(),
    );
  }
})();
/* DMIXER-VARIANT-TIERS: END — Quantity-based strike-through price sync. */